import { Link, Navigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { TbLogout } from "react-icons/tb";
import { logo } from "../../../assets";
import { decodeJWT } from "../../../utils";
import {
  MdOutlineHistory,
  MdSpaceDashboard,
  MdOutlineHome,
  MdOutlineHistoryEdu,
  MdOutlineContactPhone,
} from "react-icons/md";
import {
  HiOutlineShoppingBag,
  HiOutlineUserGroup,
  HiOutlineNewspaper,
  HiExclamation,
} from "react-icons/hi";
import { FaBars } from "react-icons/fa";
import { useState } from "react";

import { HiLockOpen, HiLockClosed } from "react-icons/hi";
import { newsAdminContext } from "../../../context/AdminContext/NewsAdminContext/NewsAdminContext";
import { useContext, useEffect } from "react";

const PublicMobileMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const token = localStorage.getItem("token");
  const isLogin = !isEmpty(token);
  const roleName = decodeJWT(token)?.usertype;

const {
  handleChangeStoreStatus,
  handleGetStoreStatus,
  isStoreCloses,
} = useContext(newsAdminContext);

useEffect(() => {
  if (roleName === "ADMIN") {
    handleGetStoreStatus();
  }
}, []);


  if (!isLogin) return <Navigate to="/" replace />;

  return (
    <>
      {/* Menu button with hamburger icon */}
      <div className="lg:hidden fixed top-4 right-4 z-50">
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="p-3 bg-[#101632] rounded-full hover:bg-[#171d3f] transition-all border border-yellow-200 duration-200 shadow-md"
        >
          <FaBars size={20} className="text-yellow-600" />
        </button>

        {/* Dropdown menu */}
        {isMenuOpen && (
          <div
            className="absolute top-14 right-0 w-64 bg-[#101632] rounded-xl 
                       p-2 shadow-xl border border-yellow-200 max-h-[80vh] 
                       overflow-y-auto space-y-1 scrollbar-thin scrollbar-thumb-yellow-700 scrollbar-track-[#101632]"
          >
            {/* Logo */}
            <div className="flex justify-center py-3 border-b border-yellow-200 border-opacity-50">
              <img src={logo} alt="Logo" className="h-12 w-12" />
            </div>

            {/* -------------------- منوی عمومی -------------------- */}
            <Link
              to="/Public/Home"
              className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <MdOutlineHome size={20} className="ml-3 text-yellow-600" />
              صفحه اصلی
            </Link>

            <Link
              to="/Public/Live-Transactions"
              className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <MdOutlineHistoryEdu size={20} className="ml-3 text-yellow-600" />
              معاملات جاری
            </Link>

            <Link
              to="/Public/Last-Transactions"
              className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <MdOutlineHistory size={20} className="ml-3 text-yellow-600" />
              آخرین معاملات
            </Link>

            <Link
              to="/Public/ContactUs"
              className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <MdOutlineContactPhone
                size={20}
                className="ml-3 text-yellow-600"
              />
              تماس با ما
            </Link>

            {/* -------------------- پنل -------------------- */}
            <Link
              to={
                roleName === "CUSTOMER"
                  ? "/Customer/Profile"
                  : "/Admin/Dashboard/Profile"
              }
              className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <MdSpaceDashboard size={20} className="ml-3 text-yellow-600" />
              {roleName === "ADMIN" ? "پنل ادمین" : "پنل کاربری"}
            </Link>

            {/* -------------------- آیتم‌های ادمین -------------------- */}
            {roleName === "ADMIN" && (
              <>
                <div className="border-t border-yellow-200 border-opacity-50 my-2"></div>

                <Link
                  to="/Admin/Dashboard/News"
                  className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                             rounded-lg transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <HiOutlineNewspaper
                    size={20}
                    className="ml-3 text-yellow-600"
                  />
                  اخبار
                </Link>

                <Link
                  to="/Admin/Dashboard/Requests"
                  className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                             rounded-lg transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <HiExclamation size={20} className="ml-3 text-yellow-600" />
                  درخواست‌ها
                </Link>

                <Link
                  to="/Admin/Dashboard/Products"
                  className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                             rounded-lg transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <HiOutlineShoppingBag
                    size={20}
                    className="ml-3 text-yellow-600"
                  />
                  محصولات
                </Link>

                <Link
                  to="/Admin/Dashboard/Users"
                  className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                             rounded-lg transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <HiOutlineUserGroup
                    size={20}
                    className="ml-3 text-yellow-600"
                  />
                  کاربران
                </Link>
              </>
            )}

            {/* -------------------- خروج -------------------- */}
            <div className="border-t border-yellow-200 border-opacity-50 my-2"></div>
{roleName === "ADMIN" && (
  <>
    <div className="border-t border-yellow-200 border-opacity-50 my-2"></div>
    
    {isStoreCloses === true ? (
      <button
        onClick={() => {
          handleChangeStoreStatus(false);
          setIsMenuOpen(false);
        }}
        className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                   rounded-lg transition-colors duration-200"
      >
        <HiLockClosed size={20} className="ml-3 text-red-600" />
        فعال کردن فروشگاه
      </button>
    ) : (
      <button
        onClick={() => {
          handleChangeStoreStatus(true);
          setIsMenuOpen(false);
        }}
        className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                   rounded-lg transition-colors duration-200"
      >
        <HiLockOpen size={20} className="ml-3 text-green-600" />
        غیرفعال کردن فروشگاه
      </button>
    )}
  </>
)}
            <Link
              to="/Log-Out"
              className="flex items-center w-full px-4 py-3 text-white hover:text-yellow-600 hover:bg-[#171d3f]
                         rounded-lg transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              <TbLogout size={20} className="ml-3 text-yellow-600" />
              خروج از حساب
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default PublicMobileMenu;
